<template>
  <ValidationObserver ref="userRegisterForm">
    <b-form class="form" @submit.stop.prevent="onSubmit">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-6">
            <!-- <div class="welcome-login">
              <img src="/media/backgrounds/welcome-bg-blue.png" />
            </div> -->
            <div class="choose-account-type">
              <h2>Account-Typ wählen</h2>
              <div class="row">
                <div
                  :class="
                    selctedAccountType == 'consumer'
                      ? 'col-md-6 selected-account-type'
                      : 'col-md-6'
                  "
                >
                  <div class="first-box active-box">
                    <a @click="() => (selctedAccountType = 'consumer')">
                      <img src="/media/images/customer-new.png" alt="Consumer Image"  width="150px" v-schema="{ prop: 'image' }" />
                      <span>Kunde</span>
                      <i class="mdi mdi-check-circle"></i>
                    </a>
                  </div>
                </div>
                <div
                  :class="
                    selctedAccountType == 'dealer'
                      ? 'col-md-6 selected-account-type'
                      : 'col-md-6'
                  "
                >
                  <div class="first-box active-box">
                    <a @click="() => (selctedAccountType = 'dealer')">
                      <img src="/media/images/provider-new.png" alt="Provider Image" width="150px" v-schema="{ prop: 'image' }" />
                      <span>Händler</span>
                      <i class="mdi mdi-check-circle"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="text-center selcted-account-type">
                <h5>
                  {{
                    selctedAccountType === "dealer"
                      ? "Hallo lieber Händler!"
                      : "Hallo lieber Kunde!"
                  }}
                  <br />
                </h5>
                <small v-if="selctedAccountType === 'dealer'">
                  Bitte füllen sie die erforderlichen Daten zur Registrierung aus.<br>
                  Es gelten die <a href="https://www.gustoreich.at/haendler-agb.php" target="_blank">Allgemeinen Geschäftsbedingungen für gewerbliche Nutzer der Vermittlungsplattform gustoreich.at</a>. 
                  Bitte beachten Sie auch unsere <a target="_blank" href="https://gustoreich.at/ds-vereinbarung.php">Datenschutzerklärung</a></small
                >
                <small v-else>
                  Bitte füllen sie die erforderlichen Daten zur Registrierung aus.<br>
                  Es gelten die <a href="https://gustoreich.at/nutzungsbedingungen.php" target="_blank">Allgemeinen Nutzungsbedingungen für User der Vermittlungsplattform gustroreich.at</a>. Bitte beachten Sie auch unsere <a target="_blank" href="https://gustoreich.at/datenschutzerklaerung.php">Datenschutzerklärung</a>.
                </small>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-wraapper-inner">
              <h2>Registrierung</h2>
              <p>
                Bitte füllen Sie die Formularfelder aus um einen Account
                anzulegen.
              </p>

              <div v-if="formErr" role="alert" class="alert alert-danger">
                <div class="alert-text">{{ formErr }}</div>
              </div>

              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :custom-messages="{
                  required: 'Der Vorname ist erforderlich',
                }"
              >
                <v-text-field
                  autocomplete="new-password"
                  v-model="form.firstName"
                  :error-messages="errors[0]"
                  label="Vorname"
                  outlined
                ></v-text-field>
              </ValidationProvider>

              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :custom-messages="{
                  required: 'Der Nachname ist erforderlich',
                }"
              >
                <v-text-field
                  autocomplete="new-password"
                  v-model="form.lastName"
                  :error-messages="errors[0]"
                  label="Nachname"
                  outlined
                ></v-text-field>
              </ValidationProvider>

              <ValidationProvider
                name="email"
                rules="required|email"
                v-slot="{ errors }"
                :custom-messages="{
                  required: 'Die E-Mail ist erforderlich',
                }"
              >
                <v-text-field
                  autocomplete="new-password"
                  v-model="form.email"
                  :error-messages="errors[0]"
                  label="E-Mail"
                  outlined
                ></v-text-field>
              </ValidationProvider>

              <ValidationProvider
                name="email confirmation"
                rules="required|confirmed:email"
                v-slot="{ errors }"
                :custom-messages="{
                  required: 'Bitte das E-Mail bestätigen',
                }"
              >
                <v-text-field
                  autocomplete="new-password"
                  v-model="form.reEmail"
                  :error-messages="errors[0]"
                  label="E-Mail bestätigen"
                  outlined
                ></v-text-field>
              </ValidationProvider>

              <ValidationProvider
                name="Password"
                vid="password"
                :rules="
                  selctedAccountType == 'dealer'
                    ? 'required|passwordInput'
                    : 'required|passwordConsumerInput'
                "
                v-slot="{ errors }"
                :custom-messages="{
                  required: 'Das Passwort ist erforderlich',
                }"
                >
                <div class="password-input-div">
                  <v-text-field
                    :type="show === true ? 'text' : 'password'"
                    autocomplete="new-password"
                    v-model="form.password"
                    @input="passwordCheck"
                    :error-messages="errors[0]"
                    label="Passwort"
                    outlined
                  ></v-text-field>
                  <i
                    class="fas fa-eye show-icon"
                    v-if="show"
                    @click="show = !show"
                  ></i>
                  <i
                    class="fas fa-eye-slash show-icon"
                    v-else
                    @click="show = !show"
                  ></i>
                </div>
                <div
                  v-if="form.password"
                  class="row ml-0 mr-0 password-strength mt-3"
                >
                  <div class="col-md-10 p-0">
                    <v-progress-linear
                      :value="progressValue"
                      :color="progressColor"
                    ></v-progress-linear>
                  </div>
                  <div class="col-md-2 pr-0 text-right">
                    <span>{{ passwordStrength }}</span>
                  </div>
                </div>
                <div class="note-text text-secondary mb-5">
                  <small>
                    Das Passwort muss mindestens
                    {{ selctedAccountType == "producer" ? "8" : "6" }} Zeichen
                    enthalten, darunter je mindestens ein Sonderzeichen, eine
                    Zahl, sowie einen Kleinbuchstaben und einen Großbuchstaben.
                  </small>
                </div>
              </ValidationProvider>

              <ValidationProvider
                name="Password confirmation"
                rules="required|confirmed:password"
                v-slot="{ errors }"
                :custom-messages="{
                  required: 'Bitte das Passwort bestätigen',
                }"
              >
                <div class="password-input-div">
                  <v-text-field
                    :type="show2 === true ? 'text' : 'password'"
                    autocomplete="new-password"
                    v-model="form.rePassword"
                    :error-messages="errors[0]"
                    label="Passwort bestätigen"
                    outlined
                  ></v-text-field>
                  <i
                    class="fas fa-eye show-icon"
                    v-if="show2"
                    @click="show2 = !show2"
                  ></i>
                  <i
                    class="fas fa-eye-slash show-icon"
                    v-else
                    @click="show2 = !show2"
                  ></i>
                </div>
              </ValidationProvider>
              <!--               <p>
                By creating an account you agree to our
                <a href="#">Terms & Privacy</a>.
              </p> -->

              <v-btn
                type="submit"
                ref="kt_form_submit_btn"
                class="submit-btn-fill-color mt-3"
                :disabled="isDisabled"
              >
                {{ registerText }}
              </v-btn>

              <div class="signin">
                <p>
                  Haben Sie schon einen Account?
                  <router-link to="/anmeldung"
                    >Melden Sie sich bitte an.</router-link
                  >
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-12 go-to-home-page mt-8 text-center">
            <router-link to="/">
              <v-btn depressed class="outline-button"
                ><b-icon icon="arrow-left" class="mr-3"></b-icon>Zurück zur
                Startseite</v-btn
              >
            </router-link>
          </div>
        </div>
      </div>
    </b-form>
  </ValidationObserver>
</template>

<script>
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import { LOGIN } from "@/core/services/store/auth.module";
import { alpha } from "vee-validate";
import userAPI from "@/api/user";
import { extend } from "vee-validate";

extend("passwordInput", {
  message: (field) => "enter valid value",
  validate: (value) => {
    var regx = /^(?=.*[A-Za-z])(?=.*[!@#$%^&*()_+,.\\\/;':"-]).{8,}$/;
    var validPassword = regx.test(value);
    if (validPassword) {
      return true;
    } else {
      false;
    }
  },
});
extend("passwordConsumerInput", {
  message: (field) => "enter valid value",
  validate: (value) => {
    var regx = /^(?=.*[A-Za-z])(?=.*[!@#$%^&*()_+,.\\\/;':"-]).{8,}$/;
    var validPassword = regx.test(value);
    if (validPassword) {
      return true;
    } else {
      false;
    }
  },
});

export default {
  name: "Register",
  data() {
    return {
      selctedAccountType: this.$route.query.type ? this.$route.query.type : "consumer",
      registerText: "Registrierung",
      btnDisable: false,
      show: false,
      show2: false,
      isPoor: false,
      isGood: false,
      isStrong: false,
      passwordStrength: "Poor",
      contains_lovercase: false,
      contains_number: false,
      contains_uppercase: false,
      containSpecialChar: false,
      progressValue: 0,
      progressColor: "error",
      form: {
        firstName: "",
        lastName: "",
        email: "",
        reEmail: "",
        password: "",
        rePassword: "",
      },
      formErr: null,
    };
  },
  watch: {
    selctedAccountType: function () {
      this.form.password = "";
      this.form.rePassword = "";
    },
  },
  methods: {
    passwordCheck(val) {
      this.contains_lovercase = /[a-z]/.test(this.form.password);
      this.contains_number = /\d/.test(this.form.password);
      this.contains_uppercase = /[A-Z]/.test(this.form.password);
      this.containSpecialChar = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(
        this.form.password
      );

      if (this.selctedAccountType === "consumer") {
        if (this.form.password.length > 0 && this.form.password.length <= 6) {
          this.isPoor = true;
          this.passwordStrength = "Poor";
          this.progressValue = 33;
          this.progressColor = "error";
        } else {
          this.isPoor = false;
        }
        if (this.form.password.length > 6) {
          this.isGood = true;
          this.passwordStrength = "Good";
          this.progressValue = 66;
          this.progressColor = "yellow darken-2";
        } else {
          this.isGood = false;
        }
        if (
          this.form.password.length > 6 &&
          this.contains_lovercase &&
          this.contains_number &&
          this.contains_uppercase &&
          this.containSpecialChar
        ) {
          this.isStrong = true;
          this.passwordStrength = "Strong";
          this.progressValue = 100;
          this.progressColor = "green";
        } else {
          this.isStrong = false;
        }
      } else {
        if (this.form.password.length > 0 && this.form.password.length <= 8) {
          this.isPoor = true;
          this.passwordStrength = "Poor";
          this.progressValue = 33;
          this.progressColor = "error";
        } else {
          this.isPoor = false;
        }
        if (this.form.password.length > 8) {
          this.isGood = true;
          this.passwordStrength = "Good";
          this.progressValue = 66;
          this.progressColor = "yellow darken-2";
        } else {
          this.isGood = false;
        }
        if (
          this.form.password.length > 8 &&
          this.contains_lovercase &&
          this.contains_number &&
          this.contains_uppercase &&
          this.containSpecialChar
        ) {
          this.isStrong = true;
          this.passwordStrength = "Strong";
          this.progressValue = 100;
          this.progressColor = "green";
        } else {
          this.isStrong = false;
        }
      }
    },
    onSubmit() {
      this.formErr = null;
      this.$refs.userRegisterForm.validate().then((success) => {
        if (success) {
          this.btnDisable = true;
          this.registerText = "Registrierung läuft...";
          let data = {
            account_type:
              this.selctedAccountType == "dealer"
                ? "producer"
                : this.selctedAccountType,
            first_name: this.form.firstName,
            last_name: this.form.lastName,
            email: this.form.email,
            password: this.form.password,
          };
          // console.log(data);
          userAPI
            .userRegister(data)
            .then((response) => {
              if (response.status == "success") {
                let userData = {
                  email: this.form.email,
                  password: this.form.password,
                };
                this.$store
                  .dispatch(LOGIN, userData)
                  .then((response) => {
                    if (response.login_status === "success") {
                      // send data to Google tag manager
                      if (process.env.NODE_ENV === 'production') {
                        dataLayer.push({event: 'email click',eventCategory: 'Registration','eventAction': 'click',eventLabel: 'contact',debug_mode:true});
                        dataLayer.push({event: 'Account registered',eventCategory: 'Account','eventAction': 'registration',eventLabel: 'consumer',debug_mode:true});
                        // send data to google Analytics
                        this.$ga.event('Account', 'Registrierung', 'Konsument')
                        // facebook pixel code
                        fbq('track', 'Complete Registration');
                      }
                      this.btnDisable = false;
                      this.registerText = "Registrierung";
                      switch (response.role) {
                        case "admin":
                          this.$router.push({
                            name: "admin-dashboard",
                          });
                          break;

                        case "producer":
                          this.$router.push({
                            name: "producer-dashboard",
                          });
                          break;

                        default:
                          this.$router.push({
                            name: "index",
                          });
                      }
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              } else {
                this.btnDisable = false;
                this.registerText = "Registrierung";
                if (response.msg.email) {
                  this.formErr = response.msg.email[0];
                } else {
                  this.formErr = response.msg;
                }
              }
            })
            .catch((err) => {
              this.btnDisable = false;
              this.registerText = "Registrierung";
              this.formErr = err;
            });
        }
      });
    },
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
.password-input-div {
  position: relative;
}
.show-icon {
  position: absolute;
  top: 22px;
  right: 20px;
  cursor: pointer;
}

.strendth-div {
  border: 1px solid lightgrey;
  height: 7px;
  margin: 2px;
  border-radius: 10px;
}
.red {
  background-color: red;
}

.orange {
  background-color: orange;
}

.green {
  background-color: green;
}
</style>